import { useTranslation } from "react-i18next";
import NextLink from "next/link";

import { Avatar, Box, Link, Typography } from "@mui/material";

// import KrogareLogo from "../../../../public/img/krogarebonus-logo-small.svg";
import { SolidMail as EmailIcon } from "../../../icons/solid-mail";

import {
  ContactIconWrapper,
  ContactLink,
  ContactUsBox,
  EmailIconStyles,
  ParslyBoxContent,
  // ParslyLogoWrapper,
  ParslyWrapper,
} from "./styles";
import { ILeftSideMessage } from "./LeftSideMessage.types";
// import i18n from "../../../utils/i18n";

export function ContactPage() {
  return (
    <Link href="info@krogare.se">
      <a>Email Me</a>
    </Link>
  );
}
const LeftSideMessage = ({ title, message, secondText }: ILeftSideMessage) => {
  const { t } = useTranslation();

  return (
    <Box sx={ParslyWrapper}>
      <Box sx={ParslyBoxContent}>
        {/*<Box sx={ParslyLogoWrapper} data-testid="parsly-logo-sidebar" >*/}
        {/*  <KrogareLogo />*/}
        {/*</Box>*/}
        <Box sx={ContactUsBox}>
          <NextLink href={"mailto:info@krogare.se"} target={"_blank"} passHref>
            <Link sx={ContactLink}>
              <Avatar sx={ContactIconWrapper}>
                <EmailIcon sx={EmailIconStyles} />
              </Avatar>
              <Typography variant="overline">
                {t("login_page__contact-us")}
              </Typography>
            </Link>
          </NextLink>
        </Box>
        <Box sx={{ mt: "4.8rem" }}>
          <Typography variant="h1">{t(title)}</Typography>
          <Typography
            color="textSecondary"
            variant="body1"
            sx={{ mt: ".8rem" }}
          >
            {t(message)}
          </Typography>
          {secondText ? (
            <Typography color="textSecondary" variant="body1">
              {t(secondText)}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default LeftSideMessage;
